import { getDeviceConfig } from '@/device/deviceConfig'
import { performanceProfile } from '@/device/performanceProfile'
import { setReduceMotionDefault } from '@/util/reducedMotion'
import { isLegacyEngine, LEGACY_ENGINE_CLASS } from '@/device/legacyEngine'

export function initializeDeviceStyling() {
    const { deviceType, performanceTier } = getDeviceConfig()
    const classList = document.documentElement.classList
    classList.add(deviceType, `perf-${performanceTier}`)
    setReduceMotionDefault(performanceProfile(performanceTier).reduceMotionByDefault)
    if (isLegacyEngine()) classList.add(LEGACY_ENGINE_CLASS)
}
